import { Component, h, Prop, State, Watch } from '@stencil/core';

@Component({
  tag: 'wog-icon-smiley-face',
})
export class IconSmileyFace {
  @State() dismiss: boolean;
  @Prop() exit: boolean;

  @Watch('exit')
  watchExitHandle(newValue: boolean) {
    setTimeout(() => (this.dismiss = newValue), 200);
  }

  componentWillLoad() {
    this.dismiss = this.exit;
  }

  render() {
    const classes = {
      'wog--feedback-icon': true,
      'wog--icon__hide': this.exit,
      'wog--icon__show': !this.exit,
    };
    if (this.dismiss) {
      return;
    }
    return (
      <div class={classes}>
        <svg
          id="happy-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          viewBox="0 0 70 70">
          <g>
            <path
              id="Fill-4"
              d="M35 54.3c-7.3 0-14.5-2.9-20-8.7-.9-1-.9-2.5 0-3.5s2.4-1 3.3 0c9.2 9.6 24.2 9.7 33.4 0 .9-1 2.4-1 3.3 0 .9 1 .9 2.5 0 3.5-5.5 5.8-12.8 8.7-20 8.7"
            />
            <path
              id="Fill-6"
              d="M21.4 32.9c-2.4 0-4.3-1.7-4.3-3.7v-2.5c0-2.1 1.9-3.7 4.3-3.7s4.3 1.7 4.3 3.7v2.5c0 2-1.9 3.7-4.3 3.7"
            />
            <path
              id="Fill-8"
              d="M48.6 32.9c-2.4 0-4.3-1.7-4.3-3.7v-2.5c0-2.1 1.9-3.7 4.3-3.7s4.3 1.7 4.3 3.7v2.5c0 2-2 3.7-4.3 3.7"
            />
          </g>
        </svg>
      </div>
    );
  }
}
